<style scoped lang="less">
.expense-group {
  color: #57a3f3;
  cursor: pointer;
}

.asset {
  /deep/.asset-table {
    /deep/ .red-row {
      color: #ff9900;
      background: #f8f8f9;
    }
  }
}

.search-input {
  display: inline-block;
  min-width: 250px;
  max-width: 600px;
}

.search-item {
  padding: 4px 8px;
  cursor: pointer;
  border: 1px solid #dddee1;
  border-radius: 6px;
  margin: 5px 0;
}

.search-item:hover {
  background: #f5f5f5;
}

.searched-customer {
  display: inline-block;
  padding: 2px 4px;
  border: 1px solid #dddee1;
  margin-right: 5px;
  margin-bottom: 5px;
  cursor: pointer;
}

.searched-customer:hover {
  background: #e5e5e5;
}

.asset-extra {
  white-space: pre-line;
  text-align: left;
}

.order-select {
  transform: translateY(0px);
}

.edit-container {
  margin: 0 auto;
  max-width: 800px;
}

.edit-container .ivu-btn {
  padding-left: 7px;
  padding-right: 7px;
  text-align: left;
}

.edit-container .ivu-form-item {
  // margin-bottom: 8px;
}

.payee-company-account-name {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
<template>
  <div class="asset">
    <div class="line text-center">
      <Select
        v-model="params.order"
        class="order-select"
        transfer
        style="width: 140px"
        @on-change="doSearch"
      >
        <Option value="sort_id"> 按录入时间排序 </Option>
        <Option value="get_date_id"> 按领用时间排序 </Option>
      </Select>
      <space />
      <Select
        v-model="params.asset_device_type_id"
        placeholder="选择设备类型"
        style="width: 140px"
        @on-change="changeAssetDeviceType"
      >
        <Option :value="0"> 所有设备类型 </Option>
        <Option
          v-for="item in asset_device_types"
          :key="item.id"
          :value="item.id"
        >
          {{ item.name }}
        </Option>
      </Select>
      <space />
      <Select
        v-model="params.asset_name_id"
        placeholder="选择设备名称"
        style="width: 140px"
        @on-change="doSearch"
      >
        <Option :value="0"> 所有名称 </Option>
        <Option
          v-for="item in asset_names_search"
          :key="item.id"
          :value="item.id"
        >
          {{ item.name }}
        </Option>
      </Select>
      <space />
      <Select
        v-model="params.asset_stock_id"
        placeholder="选择仓库"
        style="width: 140px"
        @on-change="doSearch"
      >
        <Option :value="0"> 所有仓库 </Option>
        <Option v-for="item in asset_stocks" :key="item.id" :value="item.id">
          {{ item.name }}
        </Option>
      </Select>
      <space />
      <Select
        v-model="params.monthly_payment_asset"
        placeholder="选择资产"
        style="width: 140px"
        @on-change="doSearch"
      >
        <Option :value="0"> 所有资产 </Option>
        <Option :value="1"> 月结资产 </Option>
      </Select>
    </div>
    <div class="line text-center">
      <Select
        v-model="params.company_id"
        placeholder="选择公司"
        style="width: 140px"
        @on-change="doSearch"
      >
        <Option :value="0"> 所有公司 </Option>
        <Option v-for="item in companies" :key="item.id" :value="item.id">
          {{ item.name }}
        </Option>
      </Select>
      <space />
      <Select
        v-model="params.asset_location_id"
        placeholder="选择地点"
        style="width: 140px"
        @on-change="doSearch"
      >
        <Option :value="0"> 所有地点 </Option>
        <Option v-for="item in asset_locations" :key="item.id" :value="item.id">
          {{ item.name }}
        </Option>
      </Select>
      <space />
      <Select
        v-model="params.team_id"
        placeholder="选择项目组"
        style="width: 140px"
        @on-change="doSearch"
      >
        <Option :value="0"> 所有项目组 </Option>
        <Option v-for="team in teams" :key="team.id" :value="team.id">
          {{ team.name }}
        </Option>
      </Select>
      <Select
        v-model="params.asset_purpose_id"
        placeholder="请选择资产用途"
        style="width: 140px"
        @on-change="doSearch"
      >
        <Option :value="0"> 所有用途 </Option>
        <Option v-for="team in asset_purposes" :key="team.id" :value="team.id">
          {{ team.name }}
        </Option>
      </Select>
      <space />
      <Select
        v-model="params.customer_type"
        placeholder="员工类型"
        style="width: 140px"
        clearable
        @on-change="doSearch"
      >
        <Option
          v-for="type in staff_type_list"
          :key="type.key"
          :value="type.key"
        >
          {{ type.title }}
        </Option>
      </Select>
      <space />
      <CustomerSelector
        v-model="params.customer_id"
        clearable
        placeholder="请选择领用人"
        style="width: 140px"
        @on-change="doSearch"
      />
    </div>
    <div class="line text-center">
      <Button type="primary" icon="md-add" @click="editAsset(new_asset)">
        添加
      </Button>
      <space />
      <div class="search-input">
        <i-input
          v-model="params.search"
          placeholder="请输入搜索关键字"
          @on-enter="doSearch"
        />
      </div>
      <space />
      <Ajaxbtn
        ref="searchBtn"
        :url="query_asset_path"
        :params="params_proxy"
        type="search"
        @before="beforeSearch"
        @done="handleData"
        @fail="handleFail"
      />
      <space />
      <Poptip placement="bottom">
        <Badge :count="print_list.length">
          <Button>
            <span>待打印领用表</span>
            <span v-if="print_list_owner_account"
              >({{ print_list_owner_account }})</span
            >
          </Button>
        </Badge>
        <div slot="content">
          <div class="line">
            <Button type="warning" icon="md-print" @click="printApplications">
              打印领用单
            </Button>
            <Button
              class="pull-right"
              type="error"
              icon="md-close"
              @click="clearPrintList"
            >
              清除
            </Button>
          </div>
          <div class="line">
            <table class="mis-table">
              <tr>
                <th>资产</th>
                <th>型号</th>
                <th>领用人</th>
                <th>操作</th>
              </tr>
              <tr v-for="(asset, index) in print_list" :key="asset.id">
                <td>{{ asset.asset_name.name }}</td>
                <td>{{ asset.asset_version.name || asset.asset_model }}</td>
                <td>{{ asset.customer && asset.customer.account }}</td>
                <td>
                  <Button
                    shape="circle"
                    size="small"
                    icon="md-arrow-up"
                    @click="moveUpAssetInPrintList(index)"
                  />
                  <Button
                    shape="circle"
                    size="small"
                    icon="md-arrow-down"
                    @click="moveDownAssetInPrintList(index)"
                  />
                  <Button
                    shape="circle"
                    size="small"
                    icon="md-close"
                    @click="removeAssetInPrintList(index)"
                  />
                </td>
              </tr>
            </table>
          </div>
        </div>
      </Poptip>
      <space />
      <!-- <Button @click="importAssets">导入初始化数据</Button> -->
      <Button @click="exportAssets"> 导出Excel </Button>
      <space />
      <space />
      <Button @click="batchProcessing"> 批量处理 </Button>
    </div>

    <Table
      ref="assets"
      class="asset-table"
      size="small"
      :columns="asset_columns"
      :data="assets"
      :loading="loading"
      :row-class-name="rowClassName"
      border
      @on-select="addSelection"
      @on-select-all="setSelections"
      @on-select-cancel="removeSelection"
      @on-select-all-cancel="clearSelection"
    />

    <div v-show="page_info.total" class="line paginate-fix-bottom">
      <Page
        show-total
        show-elevator
        :current="page_info.current"
        :total="page_info.total"
        :page-size="page_info.page_size"
        @on-change="pageChange"
      />
    </div>
    <Modal
      v-model="edit_asset_payment_table.modal"
      fullscreen
      title="付款单生成-资产列表"
      ok-text="生成付款单"
      :mask-closable="false"
      :loading="edit_asset_payment_table.loading"
      @on-ok="doGenerateExpenseGroup"
    >
      <div class="line list-container">
        <Table
          ref="edit_asset_payment"
          size="small"
          :columns="asset_payment_table_columns"
          :data="asset_payment_table_data"
          :loading="loading"
          border
        />
      </div>
    </Modal>
    <Modal
      v-model="edit_config.modal"
      fullscreen
      title="添加 / 编辑"
      ok-text="保存"
      :mask-closable="false"
    >
      <Form
        ref="form"
        :model="edit_asset"
        class="edit-container"
        :label-width="80"
        :rules="rules"
      >
        <div class="line">
          <Row style="min-height: 70px" :gutter="4">
            <i-col span="8">
              <FormItem label="资产编号" prop="uid">
                <i-input v-model.trim="edit_asset.uid" />
              </FormItem>
            </i-col>
            <i-col span="8">
              <FormItem label="设备类型" prop="asset_device_type_id">
                <Select
                  v-model="edit_asset.asset_device_type_id"
                  placeholder="选择设备类型"
                  @on-change="changeDeviceType"
                >
                  <Option :value="0"> 无 </Option>
                  <Option
                    v-for="item in asset_device_types"
                    :key="item.id"
                    :value="item.id"
                  >
                    {{ item.name }}
                  </Option>
                </Select>
              </FormItem>
            </i-col>
            <i-col span="8">
              <FormItem label="资产名称" prop="asset_name_id">
                <Select
                  v-model="edit_asset.asset_name_id"
                  filterable
                  placeholder="选择名称"
                >
                  <Option
                    v-for="item in asset_names_dispaly_arr"
                    :key="item.id"
                    :value="item.id"
                  >
                    {{ item.name }}
                  </Option>
                </Select>
              </FormItem>
            </i-col>
          </Row>
          <Row :gutter="4">
            <i-col span="8">
              <FormItem label="资产型号" prop="asset_version">
                <Select
                  v-model="edit_asset.asset_version_id"
                  filterable
                  placeholder="选择型号"
                >
                  <Option
                    v-for="item in asset_versions_display_arr"
                    :key="item.id"
                    :value="item.id"
                  >
                    {{ item.name }}
                  </Option>
                </Select>
              </FormItem>
            </i-col>
            <i-col span="8">
              <FormItem label="所属公司" prop="company_id">
                <Select
                  v-model="edit_asset.company_id"
                  transfer
                  placeholder="所属公司"
                >
                  <Option
                    v-for="company in companies"
                    :key="company.id"
                    :value="company.id"
                  >
                    {{ company.short_name }}
                  </Option>
                </Select>
              </FormItem>
            </i-col>
            <i-col span="8">
              <FormItem label="所属项目组" prop="team_id">
                <label>
                  <Select
                    v-model="edit_asset.team_id"
                    transfer
                    placeholder="所属项目组"
                  >
                    <Option
                      v-for="team in teams"
                      v-show="!team.del"
                      :key="team.id"
                      :value="team.id"
                    >
                      {{ team.name }}
                    </Option>
                  </Select>
                </label>
              </FormItem>
            </i-col>
            <i-col span="8">
              <FormItem label="设备品牌" prop="asset_brand_id">
                <Select
                  v-model="edit_asset.asset_brand_id"
                  placeholder="选择品牌"
                >
                  <Option
                    v-for="item in asset_brands"
                    :key="item.id"
                    :value="item.id"
                  >
                    {{ item.name }}
                  </Option>
                </Select>
              </FormItem>
            </i-col>
            <i-col span="8">
              <FormItem label="供应商" prop="payee_company_id">
                <!-- payee_company_id -->
                <PayeeAccountSelector
                  :type="payee_type"
                  :apply_user_id="cur_customer.id"
                  @on-change="setPayeeAccount"
                >
                  <span
                    v-if="selected_payee_company_account_name"
                    class="payee-company-account-name"
                    >{{ selected_payee_company_account_name }}</span
                  >
                  <span v-else class="color-grey">选择</span>
                </PayeeAccountSelector>
              </FormItem>
            </i-col>
            <i-col span="8">
              <FormItem label="SN" prop="sn">
                <i-input v-model.trim="edit_asset.sn" placeholder="SN" />
              </FormItem>
            </i-col>
            <i-col span="8">
              <FormItem label="地点" prop="asset_location_id">
                <Select
                  v-model="edit_asset.asset_location_id"
                  placeholder="资产所在地点"
                >
                  <Option
                    v-for="item in asset_locations"
                    :key="item.id"
                    :value="item.id"
                  >
                    {{ item.name }}
                  </Option>
                </Select>
              </FormItem>
            </i-col>
            <i-col span="8">
              <FormItem label="资产用途" prop="asset_purpose_id">
                <Select
                  v-model="edit_asset.asset_purpose_id"
                  placeholder="资产用途"
                >
                  <Option
                    v-for="item in asset_purposes"
                    :key="item.id"
                    :value="item.id"
                  >
                    {{ item.name }}
                  </Option>
                </Select>
              </FormItem>
            </i-col>
            <i-col span="8">
              <FormItem label="购买日期" prop="purchase_date">
                <DatePicker
                  v-model="edit_asset.purchase_date"
                  type="date"
                  placeholder="购买日期"
                  @on-change="purchaseDateChange"
                />
              </FormItem>
            </i-col>
            <i-col span="8">
              <FormItem label="购入价格" prop="price">
                <i-input
                  v-model.trim="edit_asset.price"
                  number
                  @on-change="calculatePrice"
                />
              </FormItem>
            </i-col>
            <i-col span="8">
              <FormItem label="入账价格" prop="in_price">
                <i-input
                  v-model.trim="edit_asset.in_price"
                  number
                  @on-change="changeTax"
                />
              </FormItem>
            </i-col>
            <i-col span="8">
              <FormItem label="折旧年限" prop="depreciation_year">
                <i-input v-model.trim="edit_asset.depreciation_year" number />
              </FormItem>
            </i-col>
            <i-col span="8">
              <FormItem label="资产残值" prop="residual_value">
                <i-input v-model.trim="edit_asset.residual_value" number />
              </FormItem>
            </i-col>
            <i-col span="8">
              <FormItem label="发票类型" prop="invoice_type">
                <Select
                  v-model.trim="edit_asset.invoice_type"
                  placeholder="发票类型"
                >
                  <Option
                    v-for="item in invoice_types"
                    :key="item.value"
                    :value="item.value"
                  >
                    {{ item.name }}
                  </Option>
                </Select>
              </FormItem>
            </i-col>
            <i-col span="8">
              <FormItem
                v-if="edit_asset.invoice_type === 1"
                label="税额"
                prop="tax_point"
              >
                <i-input
                  v-model.trim="edit_asset.tax_point"
                  number
                  @on-change="changeInPrice"
                />
              </FormItem>
            </i-col>
            <i-col v-if="edit_asset.invoice_type === 1" span="8">
              <FormItem label="预估税额" prop="is_estimate_price">
                <Checkbox
                  v-model="edit_asset.is_estimate_price"
                  @on-change="calculatePrice(edit_asset.price)"
                />
              </FormItem>
            </i-col>
          </Row>
        </div>
        <!-- <Row class="line" :gutter="4">
                    <i-col span="8">
                        <FormItem label="PN">
                            <i-input v-model.trim="edit_asset.pn" placeholder="PN"></i-input>
                        </FormItem>
                    </i-col>
                    <i-col span="8">
                        <FormItem label="IMEI">
                            <i-input v-model.trim="edit_asset.imei" placeholder="IMEI"></i-input>
                        </FormItem>
                    </i-col>
                </Row> -->
        <Row class="line" :gutter="4" />
        <Row class="line" :gutter="4">
          <!--  <i-col span="8">
            <FormItem label="到货日期">
              <DatePicker
                v-model="edit_asset.arrive_date"
                type="date"
                placeholder="到货日期"
                @on-change="arriveDateChange"
              />
            </FormItem>
          </i-col> -->
        </Row>
        <Row>
          <!--  <i-col span="8">
            <FormItem label="设备状态">
              <Select
                v-model.trim="edit_asset.status"
                placeholder="设备状态"
              >
                <Option
                  v-for="item in statuses"
                  :key="item.value"
                  :value="item.value"
                >
                  {{ item.name }}
                </Option>
              </Select>
            </FormItem>
          </i-col> -->
        </Row>
        <!-- <Row
          class="line"
          :gutter="4"
        >
          <i-col span="8">
            <FormItem label="微信号码">
              <i-input
                v-model.trim="edit_asset.wechat_number"
                placeholder="设备微信绑定的微信号码"
              />
            </FormItem>
          </i-col>
          <i-col span="8">
            <FormItem label="iCloud">
              <i-input
                v-model.trim="edit_asset.icloud"
                placeholder="苹果设备的iCloud账号"
              />
            </FormItem>
          </i-col>
          <i-col span="8" />
          <i-col
            v-if="!edit_asset.id"
            span="8"
          >
            <FormItem label="资产仓库">
              <Select
                v-model.trim="edit_asset.asset_stock_id"
                placeholder="资产仓库"
              >
                <Option
                  v-for="item in asset_stocks"
                  :key="item.id"
                  :value="item.id"
                >
                  {{ item.name }}
                </Option>
              </Select>
            </FormItem>
          </i-col>
        </Row> -->
        <!--  <Row
          class="line"
          :gutter="4"
        >
          <i-col span="8">
            <FormItem label="是否退役">
              <Checkbox v-model="edit_asset.is_retire" />
            </FormItem>
          </i-col>
        </Row> -->
        <div class="line">
          <FormItem label="资产附件">
            <i-input
              v-model="edit_asset.extra"
              type="textarea"
              :rows="3"
              placeholder="备注附件"
            />
          </FormItem>
        </div>
        <div class="line">
          <FormItem label="备注">
            <RichText :config="rich_text_config" :text.sync="edit_asset.desc" />
          </FormItem>
        </div>
      </Form>
      <div slot="footer">
        <Button @click="edit_config.modal = false"> 取消 </Button>
        <Button type="primary" :loading="edit_config.loading" @click="editOK">
          确定
        </Button>
      </div>
    </Modal>

    <Modal
      v-for="index in 4"
      :key="`asset_stock_configs_${index}`"
      v-model="asset_stock_configs[index - 1].modal"
      width="619"
      :title="asset_stock_configs[index - 1].title"
      ok-text="关闭"
      cancel-text=""
      :mask-closable="false"
      @on-ok="batchCancel"
      @on-cancel="batchCancel"
    >
      <!-- <div class="line text-large">
                <span>编号: </span>
                <span class="text-bold">{{set_user_asset.uid}}</span>
                <span>名称: </span>
                <span class="text-bold">{{set_user_asset.asset_name ? set_user_asset.asset_name.name : '-'}}</span>
                <span>型号: </span>
                <span class="text-bold">{{set_user_asset.asset_model}}</span>
            </div> -->
      <!-- <div class="hr"></div> -->
      <!-- <div class="line">
                <span class="text-bold">资产所属团队: </span>
                <span class="text-bold">{{set_user_asset_team}}</span>
                <span class="link" @click="updateSetUserAssetTeam(set_user_asset, true)" v-if="!is_update_team">修改</span>
                <span class="link" @click="updateSetUserAssetTeam(set_user_asset, false)" v-else>取消修改</span>
            </div> -->
      <!-- <div class="line" v-show="is_update_team">
                <Select v-model="update_asset_team_id" placeholder="请选择团队" style="width: 150px">
                    <Option :value="team.id" v-for="team in teams" :key="team.id">{{team.name}}</Option>
                </Select>
                <Button type="primary" @click="updateAssetTeam(set_user_asset)" :loading="update_team_loading">保存</Button>
            </div> -->
      <div
        v-if="!asset_stock_configs[index - 1].multiple && set_user_asset"
        class="line"
      >
        <Table
          :columns="asset_stock_config_columns"
          :data="[set_user_asset]"
          size="small"
          border
        />
      </div>
      <div
        v-if="getReceiver(set_user_asset, index - 1).type === 'customer'"
        class="line"
      >
        <!-- <Button type="warning" @click="addCustomerToAsset({id: 0, account: '无'})">设为无使用人</Button> -->
        {{ getReceiver(set_user_asset, index - 1).name }}:
        <div class="search-input">
          <i-input
            v-model="search_customer_params.search"
            placeholder="请输入员工姓名搜索"
            @on-enter="doSearchCustomer"
          />
        </div>
        <space />
        <Ajaxbtn
          ref="searchCustomerBtn"
          :url="query_customer_path"
          :params="search_customer_params"
          :config="search_customer_config"
          @done="handleSearchCustomerData"
          @fail="handleSearchCustomerFail"
        />
      </div>
      <div v-else class="line">
        {{ getReceiver(set_user_asset, index - 1).name }}:
        <Select
          v-model.trim="selected_stock_id"
          style="width: 200px"
          placeholder="资产仓库"
        >
          <Option v-for="item in asset_stocks" :key="item.id" :value="item.id">
            {{ item.name }}
          </Option>
        </Select>
        <Button
          type="primary"
          @click="addStockToAsset(selected_stock_id, index - 1)"
        >
          确认
        </Button>
      </div>
      <div
        v-if="getReceiver(set_user_asset, index - 1).type === 'customer'"
        v-show="searched_customers.length"
        class="line"
      >
        <div class="line">点击添加</div>
        <div
          v-for="c in searched_customers"
          :key="c.id"
          class="searched-customer"
          @click="addCustomerToAsset(c, index - 1)"
        >
          <span>{{ c.team_name }}</span>
          <span> - {{ c.account }}</span>
          <span v-if="c.nickname"> - {{ c.nickname }}</span>
          <span> - {{ c.email }}</span>
        </div>
      </div>
    </Modal>

    <Modal
      v-for="index in 5"
      :key="`asset_stock_configs_sub_${index}`"
      v-model="asset_stock_configs[index - 1].sub_modal"
      width="400"
      :title="asset_stock_configs[index - 1].sub_title"
      ok-text="保存"
      :mask-closable="false"
      :loading="asset_stock_configs[index - 1].sub_loading"
      @on-ok="
        () => {
          asset_stock_configs[index - 1].multiple
            ? setMultipleUserOK(index - 1)
            : setUserOK(index - 1);
        }
      "
    >
      <div
        v-if="getReceiver(set_user_asset, index - 1).type === 'customer'"
        class="line"
      >
        <span>{{ getReceiver(set_user_asset, index - 1).name }}: </span>
        <span>{{ selected_customer.account || "无" }}</span>
        <span>{{ selected_customer.uid }}</span>
        <span>{{ selected_customer.team }}</span>
      </div>
      <div
        v-if="getReceiver(set_user_asset, index - 1).type === 'stock'"
        class="line"
      >
        <span>{{ getReceiver(set_user_asset, index - 1).name }}: </span>
        <span>{{ selected_stock.name || "无" }}</span>
      </div>
      <div class="line">
        <DatePicker
          v-model="set_customer_date"
          type="date"
          transfer
          :placeholder="asset_stock_configs[index - 1].title + '日期'"
          style="width: 200px"
          @on-change="getDateChange"
        />
      </div>
      <div class="line">
        <div class="line">备注:</div>
        <i-input
          v-model="set_customer_desc"
          type="textarea"
          placeholder="备注..."
        />
      </div>
    </Modal>

    <Modal
      v-model="import_config.modal"
      width="400"
      title="导入初始化数据"
      ok-text="关闭"
      cancel-text=""
      :mask-closable="false"
    >
      <FileUploader
        v-show="!uploading"
        :upload_path="import_path"
        :format="['xlsx']"
        @start="uploading = true"
        @done="importFinish"
        @finally="uploading = false"
      />
      <div v-show="uploading" class="text-center">
        <Spin />
        <div class="text-bold">导入中, 请耐心等待...</div>
      </div>
    </Modal>
    <Modal
      v-model="show_expense_group"
      title="付款申请单"
      ok-text="关闭"
      cancel-text=""
    >
      <Row class="line">
        <i-col span="12"> 付款号：{{ selected_expense_group.uid }} </i-col>
        <i-col span="12"> 名称：{{ selected_expense_group.name }} </i-col>
      </Row>
      <Row class="line">
        <i-col span="12">
          付款总金额：{{ selected_expense_group.total_price }}
        </i-col>
        <i-col span="12">
          付款对象：{{ selected_expense_group.payee_company }}
        </i-col>
      </Row>
      <Row class="line">
        <i-col>
          状态：
          <span v-if="selected_expense_group.status === 0"> 待财务审核 </span>
          <span v-if="selected_expense_group.status === 5"> 待付款 </span>
          <span v-if="selected_expense_group.status === 9"> 付款完成 </span>
        </i-col>
      </Row>
    </Modal>

    <Backdrop v-show="getting_target_asset" />

    <AssetPrint ref="printer" />
    <AssetApplicationPrint ref="applicationPrinter" />
    <CustomerAsset ref="CustomerAsset" />
    <AssetCheckPrint ref="assetCheckPrint" @close="closePrint" />
    <AssetCheckBatchModal
      ref="assetCheckBatchModal"
      v-model="is_batch"
      :selected-assets="selected_assets"
      :asset-columns-base="asset_columns_base"
      @del="delSelect"
    >
      <div slot="footer">
        <div class="line text-center" style="display: flex">
          <div>
            <i-input
              v-model="matching_params.search"
              style="width: 240px"
              placeholder="请输入搜索关键字"
              search
              enter-button="匹配"
              @on-search="matchingItem"
            />
          </div>
          <Button @click="multipleInStock"> 入库 </Button>
          <space />
          <Button @click="multipleProvide"> 发放 </Button>
          <space />
          <Button @click="multipleTransfer"> 转移 </Button>
          <space />
          <Button @click="multipleReturn"> 归还 </Button>
          <space />
          <Button @click="generateExpenseGroups"> 生成付款单 </Button>
          <Button @click="batchPrint"> 批量打印 </Button>
        </div>
      </div>
    </AssetCheckBatchModal>
    <!-- <InputNumber :min="1" :max="10" v-model="num"></InputNumber> -->
  </div>
</template>
<script route="/exec/assets">
import { VBtn } from "vuetify/lib";
import { residualValue } from "@/libs/asset_utils";
import Util from "../../libs/util";
import ExpenseUtil from "../../libs/expense_util";
import AssetPrint from "./components/asset_print";
import AssetCheckPrint from "./components/asset_check_print";
import AssetApplicationPrint from "./components/asset_application_print";
import CustomerAsset from "./components/customer_asset";
import FileUploader from "../components/file/uploader";
import CustomerSelector from "../components/customer/selector";
import PayeeAccountSelector from "../../views/payee_company/components/account_selector";
import { mapGetters } from "vuex";
import AssetCheckBatchModal from "./components/asset_check_batch_modal";
import { queryAssetApi } from "./service";
import { staff_type_list } from "./fields.js";
const staff_type_hash = staff_type_list.reduce((t, i) => {
  t[i.key] = i;
  return t;
}, {});
const illegality_value = ["", null];
const illegality_value_u = [...illegality_value, undefined];
const two_point = /^(\d+|\d+\.\d{1,2})$/;
export default {
  /* router_info_start */
  router_info: "/exec/assets",
  /* router_info_end */
  components: {
    AssetPrint,
    AssetApplicationPrint,
    CustomerAsset,
    FileUploader,
    CustomerSelector,
    PayeeAccountSelector,
    AssetCheckPrint,
    AssetCheckBatchModal,
  },
  data() {
    this.input_arr = [];
    this.staff_type_list = staff_type_list;
    return {
      matching_params: {
        search: "",
      },
      tax_rate: 0.13,
      show_expense_group: false,
      is_batch: 0,
      selected_expense_group: {},
      edit_asset_payment_table: {
        modal: false,
        loading: true,
      },
      check_all: false,
      indeterminate: false,
      asset_expense_group_hash: {},
      payee_type: ExpenseUtil.getPayeeType({
        payment_type: 1,
        is_outsource: false,
      }),
      selected_payee_company_account_name: "",
      selected_assets: [],
      asset_payment_table_data: [],
      searching_customer: false,
      query_asset_path: Util.api.query_asset,
      query_customer_path: Util.api.query_customer_with_team,
      import_path: Util.api.import_asset,
      search_customer_params: {
        search: "",
        //  customer_type: 'formal'
      },
      search_customer_config: {
        icon: "ios-search",
        method: "get",
        name: "搜索",
        processingName: "搜索中...",
        successedName: "搜索员工",
        failedName: "搜索失败",
      },
      rich_text_config: {
        show: true,
        fixed: false,
        show_handler: false,
        width: "100%",
        title: "备注:",
      },
      searched_customers: [],
      asset_brands: [],
      asset_brands_hash: {},
      asset_purposes: [],
      asset_purposes_hash: {},
      asset_device_types: [],
      asset_device_types_hash: {},
      asset_types: [],
      asset_types_hash: {},
      asset_names: [],
      asset_names_type_hash: {},
      asset_names_hash: {},
      asset_locations: [],
      asset_locations_hash: {},
      asset_stocks: [],
      asset_no_use_stock: {},
      asset_stocks_hash: {},
      asset_versions: [],
      payee_companys: [],
      payee_company_channels_hash: {},
      locations: ["C区办公室", "E区办公室", "北京办公室"],
      invoice_types: [
        { value: 0, name: "普票" },
        { value: 1, name: "专票" },
      ],
      statuses: [
        { value: 0, name: "活跃" },
        { value: 1, name: "报废" },
      ],
      asset_stock_configs: [
        // titles: [
        //     '入库',
        //     '发放',
        //     '转移',
        //     '归还',
        //     '废弃'
        // ],
        {
          title: "入库",
          receiver: {
            name: "入库仓库",
            type: "stock",
          },
          sub_title: "执行入库",
          modal: false,
          loading: true,
          sub_modal: false,
          sub_loading: true,
          multiple: false,
        },
        {
          title: "发放",
          receiver: {
            name: "使用人员",
            type: "customer",
          },
          sub_title: "执行发放",
          modal: false,
          loading: true,
          sub_modal: false,
          sub_loading: true,
          multiple: false,
        },
        {
          title: "转移",
          sub_title: "执行转移",
          modal: false,
          loading: true,
          sub_modal: false,
          sub_loading: true,
          multiple: false,
        },
        {
          title: "归还",
          receiver: {
            name: "归还仓库",
            type: "stock",
          },
          sub_title: "执行归还",
          modal: false,
          loading: true,
          sub_modal: false,
          sub_loading: true,
          multiple: false,
        },
        {
          title: "废弃",
          sub_title: "执行废弃",
          receiver: {
            name: "废弃",
            type: "discard",
          },
          modal: false,
          loading: true,
          sub_modal: false,
          sub_loading: true,
          multiple: false,
        },
      ],
      customer_columns: [
        {
          title: "工号",
          align: "center",
          key: "uid",
          render: (h, params) => {
            const asset_customer = params.row;
            if (asset_customer.customer_id) {
              return h("div", asset_customer.customer.uid);
            } else {
              return h("span", "-");
            }
          },
        },
        {
          title: "使用人姓名",
          align: "center",
          key: "account",
          render: (h, params) => {
            const asset_customer = params.row;
            if (asset_customer.customer_id) {
              const customers = this.set_user_asset.asset_customers;
              const is_cur = params.index === customers.length - 1;
              let text = asset_customer.customer.account;
              if (is_cur) {
                text += "(当前)";
              }
              return h(
                "div",
                {
                  class: {
                    "color-success": is_cur,
                  },
                },
                text
              );
            } else {
              return h("span", "无");
            }
          },
        },
        {
          title: "使用人所属团队",
          align: "center",
          key: "team",
          render: (h, params) => {
            const asset_customer = params.row;
            if (asset_customer.customer_id) {
              return h("div", asset_customer.customer.team);
            } else {
              return h("span", "-");
            }
          },
        },
        {
          title: "领用日期",
          align: "center",
          render: (h, params) => {
            const row = params.row;
            const get_date = row.get_date;
            const date = get_date ? this.$util.formatDate(get_date) : "-";
            return h("div", date);
          },
        },
        /*{
    title: '备注',
    key: 'desc'
},*/
        {
          title: "操作",
          align: "center",
          render: (h, params) => {
            const asset_customer = params.row;
            return h("div", [
              h("Button", {
                props: {
                  size: "small",
                  shape: "circle",
                  icon: "md-close",
                  loading: this.asset_customer_deleting,
                },
                on: {
                  click: () => {
                    this.$Modal.confirm({
                      title: "提示",
                      content: "你确定要删除吗?",
                      onOk: () => {
                        this.deleteAssetCustomer(asset_customer, params.index);
                      },
                    });
                  },
                },
              }),
            ]);
          },
        },
      ],
      asset_stock_config_columns: [
        {
          title: "编号",
          key: "uid",
          align: "center",
          width: 95,
        },
        {
          title: "名称",
          key: "name",
          align: "center",
          width: 120,
          render: (h, params) => {
            const asset_name = params.row.asset_name || {};
            return h("div", asset_name.name);
          },
        },
        {
          title: "型号",
          key: "asset_version",
          align: "center",
          width: 120,
          render: (h, params) => {
            const row = params.row;
            return h(
              "div",
              row.asset_version
                ? row.asset_version.name
                : row.asset_model
                ? row.asset_model
                : "-"
            );
          },
        },
        {
          title: "领用人",
          align: "center",
          width: 130,
          render: (h, params) => {
            const asset_customer = params.row.customer;
            if (asset_customer) {
              if (asset_customer.id) {
                return h("div", asset_customer.account);
              } else {
                return h("div", "-");
              }
            } else {
              return h("div", "-");
            }
          },
        },
        {
          title: "所在仓库",
          align: "center",
          width: 120,
          render: (h, params) => {
            const row = params.row;
            const asset_stock_id = row.asset_stock_id;
            let asset_stock = null;
            if (asset_stock_id) {
              asset_stock = this.asset_stocks_hash[asset_stock_id];
            }
            return h("div", asset_stock ? asset_stock.name : "-");
          },
        },
      ],
      asset_payment_table_columns: [
        {
          title: "资产编号",
          key: "asset_uid",
          align: "center",
        },
        {
          title: "资产名称",
          key: "asset_name",
          align: "center",
        },
        {
          title: "付款金额",
          align: "center",
          render: (h, params) => {
            return h("input", {
              attrs: {
                type: "number",
                value: params.row.payment,
              },
              class: {
                "input-form": true,
              },
              on: {
                input: (e) => {
                  const value = e.target.value;
                  if (value === "-" || value === "e") {
                    return;
                  }
                  if (value > params.row.rest_payment) {
                    e.target.value = params.row.rest_payment;
                  } else {
                    this.asset_payment_table_data[params.index].payment =
                      parseFloat(value);
                  }
                  // self.asset_payment_table_data[params.index].payment = e
                },
              },
            });
          },
        },
        {
          title: "剩余付款",
          key: "rest_payment",
          align: "center",
        },
        // {
        //     title: '操作',
        //     align: 'center',
        //     width: 85,
        //     render: (h, params) => {
        //         let row = params.row
        //         let items = []
        //         // if (FlowUtil.canEdit(row, this.cur_customer)) {
        //         //     items.push(h('DropdownItem', {
        //         //         props: {name: 'edit'}
        //         //     }, '编辑'))
        //         // }
        //         // if (FlowUtil.canEdit(row, this.cur_customer) || this.inGroup('GROUP_EXEC') ) {
        //         // }
        //         items.push(h('DropdownItem'), {
        //             props: {name: 'showExpense', divided: true}
        //         }, '查看已付款单')
        //         items.push(h('DropdownItem', {
        //             props: {name: 'delete', divided: true}
        //         }, '移除'));
        //         if (!items.length) {
        //             return h('div', '-')
        //         }
        //         return h('Dropdown', {
        //             props: {
        //                 trigger: 'click',
        //                 placement: 'left'
        //             },
        //             on: {
        //                 'on-click': (event_name) => {
        //                     this.handleEvent(event_name, row, params.index)
        //                 }
        //             }
        //         }, [
        //             h('Button', [
        //                 h('span', '操作')
        //             ]),
        //             h('DropdownMenu', {
        //                 slot: 'list'
        //             }, items)
        //         ])
        //     }
        // }
      ],
      assets: [],
      new_asset: {
        id: 0,
        uid: "",
        company_id: "",
        team_id: "",
        asset_name_id: 0,
        asset_type_id: 0,
        asset_device_type_id: 0,
        asset_brand_id: 0,
        asset_stock_id: 0,
        asset_version_id: 0,
        asset_location_id: "",
        is_estimate_price: true,
        name: "",
        sn: "",
        pn: "",
        imei: "",
        asset_model: "",
        payee_company_id: 0,
        payee_company_account_id: 0,
        purchase_date: "",
        arrive_date: "",
        price: 0.0,
        in_price: 0.0,
        residual_value: 0.0,
        tax_point: 0.0,
        depreciation_year: 3,
        purpose: "",
        is_retire: false,
        wechat_number: "",
        icloud: "",
        extra: "",
        desc: "",
        invoice_type: 1,
        status: 0,
        asset_purpose_id: 0,
      },
      params: {
        per_page: 50,
        page: 1,
        order: "sort_id",
        team_id: 0,
        asset_device_type_id: 0,
        asset_type_id: 0,
        asset_brand_id: 0,
        payee_company_id: 0,
        asset_location_id: 0,
        asset_name_id: 0,
        customer_id: 0,
        company_id: 0,
        asset_stock_id: 0,
        asset_model: "",
        asset_version_id: 0,
        search: "",
        monthly_payment_asset: 0,
        asset_purpose_id: 0,
        customer_type: "",
      },
      page_info: {
        current: 1,
        total: 0,
        page_size: 15,
      },
      edit_asset: {},
      set_user_asset: {},
      selected_stock_id: "",
      selected_stock: {},
      selected_customer: {},
      set_customer_desc: "",
      set_customer_date: "",
      edit_config: {
        modal: false,
        loading: false,
      },
      set_user_config: {
        modal: false,
        loading: true,
      },
      save_user_config: {
        modal: false,
        loading: true,
      },
      import_config: {
        modal: false,
        loading: true,
      },
      uploading: false,
      loading: false,
      getting_target_asset: false,
      update_asset_team_id: 0,
      is_update_team: false,
      update_team_loading: false,
      // search_asset_type_text: '',
      // search_asset_type_loading: false,
      // search_asset_type_results: [],
      // asset_type_hash: {},
      // search_asset_device_type_text: '',
      // search_asset_device_type_loading: false,
      // search_asset_device_type_results: [],
      // asset_device_type_hash: {},
      // search_asset_brand_text: '',
      // search_asset_brand_loading: false,
      // search_asset_brand_results: [],
      // asset_brand_hash: {},
      // search_purchase_channel_text: '',
      // search_purchase_channel_loading: false,
      // search_purchase_channel_results: [],
      // search_asset_name_text: '',
      // search_asset_name_loading: false,
      // search_asset_name_results: [],
      // asset_name_hash: {},
      // purchase_channel_hash: {},
      print_list: [],
      asset_customer_deleting: false,
      print_key: "exec_print_key",
    };
  },
  watch: {
    is_batch(val) {
      if (!val) {
        this.selected_assets = [];
      }
    },
    selected_assets() {
      this.$nextTick(() => {
        this.handleSelectItemFromModal();
      });
    },
  },
  computed: {
    params_proxy() {
      const params = {};
      Object.keys(this.params).forEach((k) => {
        if (this.params[k] !== "") {
          params[k] = this.params[k];
        }
      });
      return params;
    },
    asset_columns_base() {
      return [
        {
          type: "selection",
          width: 60,
          fixed: "left",
          align: "center",
        },
        {
          title: "编号",
          key: "uid",
          fixed: "left",
          align: "center",
          width: 150,
          render: (h, { row = {} } = {}) => {
            return h("div", {}, [
              h("span", {}, row.uid),
              h(
                VBtn,
                {
                  props: {
                    text: true,
                    color: "primary",
                    "x-small": true,
                  },
                  on: {
                    click: () => {
                      this.$refs.assetCheckPrint.print(row.uid);
                    },
                  },
                },
                "打印"
              ),
            ]);
          },
        },
        {
          title: "设备类型",
          align: "center",
          render: (h, { row }) => {
            // hash
            return h(
              "div",
              this.getItemNameById(
                "asset_device_types",
                row.asset_device_type_id
              )
            );
          },
          width: 70,
        },
        {
          title: "名称",
          key: "name",
          align: "center",
          width: 120,
          render: (h, params) => {
            const asset_name = params.row.asset_name;
            return h("div", asset_name.name);
          },
        },
        {
          title: "型号",
          key: "asset_model",
          align: "center",
          width: 120,
          render: (h, params) => {
            const row = params.row;
            return h(
              "div",
              row.asset_version
                ? row.asset_version.name
                : row.asset_model
                ? row.asset_model
                : "-"
            );
          },
        },
        {
          title: "SN",
          align: "center",
          key: "sn",
          width: 120,
          render: (h, params) => {
            const row = params.row;
            return h("div", row.sn ? row.sn : "-");
          },
        },
        {
          title: "当前使用人(领用时间)",
          align: "center",
          width: 130,
          render: (h, params) => {
            const asset_customer = params.row.customer;
            if (asset_customer && asset_customer.id) {
              const latest_in_out_record = params.row.latest_in_out_record;
              const date = latest_in_out_record.execute_date
                ? this.$util.formatDate(latest_in_out_record.execute_date)
                : "";
              return (
                <div
                  class="link"
                  vOn:click={() => {
                    this.showCustomerAssets(asset_customer);
                  }}
                  style="white-space: pre-line;"
                >
                  {`${asset_customer.account} ${date} \n ${asset_customer.email}`}
                </div>
              );
            }
            return h("div", "-");
          },
        },
        {
          title: "员工类型",
          align: "center",
          width: 120,
          key: "customer",
          render(h, { row }) {
            const customer_type = row.customer && row.customer.customer_type;
            return h(
              "span",
              (staff_type_hash[customer_type] &&
                staff_type_hash[customer_type].title) ||
                ""
            );
          },
        },
        {
          title: "项目组",
          align: "center",
          key: "team_id",
          width: 120,
          render: (h, params) => {
            const row = params.row;
            const team_id = row.team_id;
            const team = this.teams_hash[team_id];
            return h("div", team ? team.name : "-");
          },
        },
        {
          title: "公司",
          align: "center",
          key: "company_id",
          width: 120,
          render: (h, params) => {
            const row = params.row;
            const company_id = row.company_id;
            const company = this.companies_hash[company_id];
            return h("div", company ? company.short_name : "-");
          },
        },
        {
          title: "购买日期",
          align: "center",
          key: "purchase_date",
          width: 80,
        },
        {
          title: "购入价格",
          align: "center",
          render: (h, params) => {
            return h("div", "￥ " + this.formatPrice(params.row.price));
          },
          width: 100,
        },
        {
          title: "供应商",
          align: "center",
          render: (h, params) => {
            if (!params.row.payee_company_id) {
              return h("div", "未填写");
            }
            return h(
              "Tooltip",
              {
                props: {
                  content: params.row.payee_company.name,
                },
                style: {
                  width: "100%",
                },
              },
              [
                h(
                  "div",
                  {
                    style: {
                      overflow: "hidden",
                      "text-overflow": "ellipsis",
                      "white-space": "nowrap",
                    },
                  },
                  params.row.payee_company.name
                ),
              ]
            );
          },
          minWidth: 70,
        },
        {
          title: "关联付款单",
          align: "center",
          width: 120,
          render: (h, params) => {
            const group_items = [];
            const self = this;
            if (params.row.expense_groups) {
              params.row.expense_groups.map((group) => {
                group_items.push(
                  h(
                    "div",
                    {
                      class: {
                        "expense-group": true,
                      },
                      on: {
                        click() {
                          self.showExpenseGroup(group);
                        },
                      },
                    },
                    group.uid
                  )
                );
              });
            }
            return h("div", group_items.length ? group_items : "-");
          },
        },
        {
          title: "折旧年限",
          align: "center",
          render: (h, params) => {
            const row = params.row;
            const year_qty = row.depreciation_year;
            if (year_qty) {
              let info = "";
              if (row.purchase_date) {
                const get = moment(row.purchase_date);
                const now = moment();
                const month_count =
                  (now.year() - get.year()) * 12 + now.month() - get.month();
                const month_total = year_qty * 12;
                if (row.in_price) {
                  let calculate_residual_value =
                    ((Number(row.price) || 0) *
                      (Number(row.residual_value) || 0)) /
                    100;
                  calculate_residual_value = Number(
                    calculate_residual_value.toFixed(2)
                  );

                  const value_left = residualValue(
                    row.price,
                    row.residual_value,
                    month_count,
                    month_total
                  );
                  // const value_left = math.eval(`${row.in_price}*${row.residual_value}/100 + ${row.in_price}*(100-${row.residual_value})/100/${month_total}*(${month_total}-${month_count})`).toFixed(2);
                  info += `第 ${month_count}/${month_total} 期 <p>剩余 ￥${Math.max(
                    calculate_residual_value,
                    value_left
                  )}</p>`;
                }
              }
              return h("div", {
                domProps: {
                  innerHTML: `${year_qty}年 ${info}`,
                },
              });
            } else {
              return h("div", "未设置");
            }
          },
          width: 120,
        },
        {
          title: "入账价格",
          align: "center",
          render: (h, params) => {
            return h("div", "￥ " + this.formatPrice(params.row.in_price));
          },
          width: 100,
        },
        {
          title: "税额",
          align: "center",
          render: (h, params) => {
            return h("div", "￥ " + this.formatPrice(params.row.tax_point));
          },
          width: 100,
        },
        {
          title: "残值",
          align: "center",
          render: (h, params) => {
            const row = params.row;
            return h("div", `% ${row.residual_value}`);
          },
          width: 70,
        },
        {
          title: "所在仓库",
          align: "center",
          key: "asset_stock_id",
          width: 120,
          render: (h, params) => {
            const row = params.row;
            if (
              this.asset_no_use_stock &&
              this.asset_no_use_stock.id === row.asset_stock_id
            ) {
              return h("div", this.asset_no_use_stock.name);
            }
            const asset_stock_id = row.asset_stock_id;
            let asset_stock = null;
            if (asset_stock_id) {
              asset_stock = this.asset_stocks_hash[asset_stock_id];
            }
            return h("div", asset_stock ? asset_stock.name : "-");
          },
        },
        {
          title: "所在地点",
          align: "center",
          key: "location",
          width: 120,
          render: (h, params) => {
            const row = params.row;
            return h(
              "div",
              this.getItemNameById("asset_locations", row.asset_location_id)
            );
          },
        },
        {
          title: "发票类型",
          align: "center",
          render: (h, params) => {
            return h(
              "div",
              this.invoice_types.find(
                (invoice_type) => invoice_type.value === params.row.invoice_type
              ).name
            );
          },
          width: 100,
        },
        {
          title: "备注",
          align: "center",
          key: "desc",
          width: 180,
          render: (h, params) => {
            const desc = params.row.desc;
            if (desc) {
              return h("div", {
                domProps: {
                  innerHTML: desc,
                },
              });
            } else {
              return h("span", "-");
            }
          },
        },
        {
          title: "品牌",
          align: "center",
          render: (h, params) => {
            return h(
              "div",
              this.getItemNameById("asset_brands", params.row.asset_brand_id)
            );
          },
          width: 70,
        },
        {
          title: "资产用途",
          align: "center",
          key: "purpose",
          width: 120,
          render: (h, { row = {} } = {}) => {
            // asset_purposes_hash
            return h(
              "div",
              row.asset_purpose_id
                ? this.getItemNameById("asset_purposes", row.asset_purpose_id)
                : "-"
            );
          },
        },
        {
          title: "附件清单",
          align: "center",
          key: "extra",
          width: 180,
          render: (h, { row = {} } = {}) => {
            const extra = row.extra;
            if (extra) {
              return h("div", {
                class: {
                  "asset-extra": true,
                },
                domProps: {
                  innerHTML: extra,
                },
              });
            } else {
              return h("span", "-");
            }
          },
        },
        /* {
  title: '是否退役',
  align: 'center',
  key: 'is_retire',
  width: 80,
  render: (h, params) => {
    const row = params.row;
    return h('div', row.is_retire ? '是' : '否');
  }
}, */
        /*  {
  title: '资产类型',
  align: 'center',
  render: (h, params) => {
    return h('div', this.getItemNameById('asset_types', params.row.asset_type_id))
  },
  width: 70
}, */
        /*   {
  title: '到货日期',
  align: 'center',
  key: 'arrive_date',
  width: 80
}, */
        /* {
    title: 'PN',
    align: 'center',
    key: 'pn',
    width: 120
},
{
    title: 'IMEI',
    align: 'center',
    key: 'imei',
    width: 120
}, */

        /*    {
  title: '微信号',
  align: 'center',
  key: 'wechat_number',
  width: 120,
  render: (h, params) => {
    const row = params.row;
    return h('div', row.wechat_number ? row.wechat_number : '-');
  }
}, */
        /*      {
  title: 'iCloud账号',
  align: 'center',
  key: 'icloud',
  width: 120,
  render: (h, params) => {
    const row = params.row;
    return h('div', row.icloud ? row.icloud : '-');
  }
}, */
        {
          title: "操作",
          align: "center",
          fixed: "right",
          width: 270,
          renderHeader: (h) => {
            return h("div", [
              h(
                "span",
                {
                  attrs: {
                    style: "margin-right: 20px",
                  },
                },
                "操作"
              ),
              h("Checkbox", {
                props: {
                  value: this.check_all,
                  indeterminate: this.indeterminate,
                },
                on: {
                  "on-change": (value) => {
                    this.check_all = value;
                    if (value === true) {
                      this.indeterminate = false;
                      this.addAssetsToPrintList(this.assets);
                    } else {
                      this.print_list = [];
                      this.indeterminate = false;
                    }
                  },
                },
              }),
            ]);
          },
          render: (h, params) => {
            const placement =
              params.index > this.page_info.page_size - 3 ? "left-end" : "left";
            const ret = [];
            const tempList = [
              h(
                "DropdownItem",
                {
                  props: { name: "edit" },
                },
                "编辑"
              ),
              h(
                "DropdownItem",
                {
                  props: { name: "print" },
                },
                "打印标签"
              ),
              h(
                "DropdownItem",
                {
                  props: { name: "in_stock" },
                },
                "入库"
              ),
              h(
                "DropdownItem",
                {
                  props: { name: "provide" },
                },
                "发放"
              ),
              h(
                "DropdownItem",
                {
                  props: { name: "transfer" },
                },
                "转移"
              ),
              h(
                "DropdownItem",
                {
                  props: { name: "return" },
                },
                "归还"
              ),
              // h('DropdownItem', {
              //     props: {name: 'discard'}
              // }, '废弃'),
              /*h('DropdownItem', {
          props:{name: 'print_application'}
      }, '打印领用单'),*/
              h(
                "DropdownItem",
                {
                  props: { name: "copy" },
                },
                "复制一份"
              ),
              h(
                "DropdownItem",
                {
                  props: { name: "delete", divided: true },
                },
                "删除"
              ),
            ];
            const tempListLen = tempList.length;
            const dropdownList = [];
            for (let i = 0; i < tempListLen; i++) {
              if (i === 1) {
                continue;
              }
              if (i === 2) {
                if (!params.row.asset_stock_id && !params.row.customer_id) {
                  dropdownList.push(tempList[i]);
                }
              } else if (i === 3) {
                if (
                  params.row.asset_stock_id &&
                  params.row.asset_stock.asset_stock_type &&
                  !params.row.customer_id
                ) {
                  dropdownList.push(tempList[i]);
                }
              } else if (i === 4) {
                if (
                  params.row.customer_id ||
                  (params.row.asset_stock_id &&
                    params.row.asset_stock.asset_stock_type)
                ) {
                  dropdownList.push(tempList[i]);
                }
              } else if (i === 5) {
                if (params.row.customer_id) {
                  dropdownList.push(tempList[i]);
                }
              } else if (i === 6) {
                if (
                  !(
                    params.row.asset_stock_id &&
                    !params.row.asset_stock.asset_stock_type
                  )
                ) {
                  dropdownList.push(tempList[i]);
                }
              } else {
                dropdownList.push(tempList[i]);
              }
            }
            ret.push(
              h(
                "Dropdown",
                {
                  props: {
                    size: "small",
                    trigger: "click",
                    placement: placement,
                    transfer: true,
                  },
                  on: {
                    "on-click": (event_name) => {
                      this.handleAssetEvent(
                        event_name,
                        params.row,
                        params.index
                      );
                    },
                  },
                },
                [
                  h("Button", [h("span", " 操作")]),
                  h(
                    "DropdownMenu",
                    {
                      slot: "list",
                    },
                    dropdownList
                  ),
                ]
              )
            );
            ret.push(h("span", " "));
            ret.push(
              h(
                "Button",
                {
                  props: {
                    size: "small",
                    icon: "md-add",
                    disabled: this.isInPrintList(params.row),
                  },
                  on: {
                    click: () => {
                      this.addToPrintList(params.row);
                    },
                  },
                },
                "领用表"
              )
            );
            ret.push(
              h(
                "Button",
                {
                  props: {
                    size: "small",
                    icon: "md-add",
                    // disabled: this.isInPrintList(params.row)
                  },
                  on: {
                    click: () => {
                      this.printOne(params.row);
                    },
                  },
                },
                "打印"
              )
            );
            return h("div", ret);
          },
        },
      ];
    },
    asset_columns() {
      if (this.is_batch) {
        return this.asset_columns_base;
      }
      return this.asset_columns_base.slice(1);
    },
    rules() {
      return {
        uid: [
          {
            required: true,
            message: "请填写资产编号",
            trigger: "blur",
          },
          {
            required: false,
            validator: (rule, value, callback) => {
              if (!/^Z(C|L)\d{9}$/.test(value)) {
                callback(new Error("资产编号格式须为`ZC(或ZL)+9位数字`"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
        asset_device_type_id: [
          {
            required: true,
            message: "请选择设备类型",
            trigger: "blur",
            type: "number",
          },
          {
            required: true,
            validator: (rule, value, callback) => {
              if (value === 0) {
                callback(new Error("请选择设备类型"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
        asset_name_id: [
          {
            required: true,
            message: "请选择资产",
            trigger: "blur",
            type: "number",
          },
        ],
        // asset_version: [
        //   {
        //     required: true,
        //     message: '请选择资产型号',
        //     trigger: 'blur'
        //   }
        // ],
        company_id: [
          {
            required: true,
            message: "请选择公司",
            trigger: "blur",
            type: "number",
          },
        ],
        team_id: [
          {
            required: true,
            message: "请选择所属项目组",
            trigger: "blur",
            type: "number",
          },
        ],
        payee_company_id: [
          {
            required: true,
            message: "请选择公司",
            trigger: "blur",
            type: "number",
          },
          {
            required: true,
            validator: (rule, value, callback) => {
              if (value === 0) {
                callback(new Error("请选择公司"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
        asset_brand_id: [
          {
            required: true,
            message: "请选择设备品牌",
            trigger: "blur",
            type: "number",
          },
          {
            required: true,
            validator: (rule, value, callback) => {
              if (value === 0) {
                callback(new Error("请选择设备类型"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
        payee_company_account_id: [
          {
            required: true,
            message: "请选择供应商",
            trigger: "blur",
          },
        ],
        sn: [
          {
            required: true,
            message: "请填写sn",
            trigger: "blur",
          },
        ],
        asset_location_id: [
          {
            required: true,
            message: "请选择地点",
            trigger: "blur",
            type: "number",
          },
        ],
        asset_purpose_id: [
          {
            required: true,
            message: "请选择采购用途",
            trigger: "blur",
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error("请填选择采购用途"));
              } else {
                callback();
              }
            },
          },
        ],
        purchase_date: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error("请选择购买日期"));
                return;
              }
              callback();
            },
            trigger: "blur",
          },
        ],
        price: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (illegality_value_u.includes(value)) {
                callback(new Error("请填写购入价格"));
              } else if (isNaN(value) || !two_point.test(value)) {
                callback(new Error("请输入小数不超过两位的有效数字"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
        in_price: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (illegality_value_u.includes(value)) {
                callback(new Error("请填写入账价格"));
              } else if (isNaN(value) || !two_point.test(value)) {
                callback(new Error("请输入小数不超过两位的有效数字"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
        depreciation_year: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (illegality_value_u.includes(value)) {
                callback(new Error("请填写折旧年限"));
              } else if (isNaN(value) || !two_point.test(value)) {
                callback(new Error("请输入小数不超过两位的有效数字"));
              } else if (Number(value) <= 0) {
                callback(new Error("折旧年限需大于0"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
        residual_value: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (illegality_value_u.includes(value)) {
                callback(new Error("请填写资产残值"));
              } else if (isNaN(value) || !two_point.test(value)) {
                callback(new Error("请输入小数不超过两位的有效数字"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
        invoice_type: [
          {
            required: true,
            message: "请选择发票类型",
            trigger: "blur",
            type: "number",
          },
        ],
        tax_point: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (illegality_value_u.includes(value)) {
                callback(new Error("请填写资产残值"));
              } else if (isNaN(value) || !two_point.test(value)) {
                callback(new Error("请输入小数不超过两位的有效数字"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
        // is_estimate_price: [
        //   {
        //     required: true,
        //     message: '请选择预估税额',
        //     trigger: 'blur'
        //   }
        // ]
      };
    },
    print_list_owner_account() {
      if (this.print_list.length) {
        return (
          this.print_list[0].customer && this.print_list[0].customer.account
        );
      } else {
        return "";
      }
    },
    ...mapGetters({
      companies: "async/companies",
      companies_hash: "async/companies_hash",
      teams: "async/root_teams",
      teams_hash: "async/root_teams_hash",
      jobs: "async/jobs",
      jobs_hash: "async/jobs_hash",
    }),
    set_user_asset_team() {
      const team_id = this.set_user_asset.team_id;
      const team = this.teams_hash[team_id];
      return team ? team.name : "无";
    },
    cur_customer() {
      return this.$store.state.cur_customer;
    },
    asset_names_dispaly_arr() {
      return this.asset_names.filter(
        (item) =>
          this.edit_asset.asset_device_type_id === item.asset_device_type_id
      );
    },
    asset_versions_display_arr() {
      return this.asset_versions.filter(
        (item) =>
          this.edit_asset.asset_device_type_id === item.asset_device_type_id &&
          this.edit_asset.asset_name_id === item.asset_name_id
      );
    },
    asset_names_search() {
      if (!this.params.asset_device_type_id) {
        return this.asset_names;
      }
      const arr =
        this.asset_names_type_hash[this.params.asset_device_type_id] || [];
      return arr;
      //  return this.asset_names.filter(item => this.params.asset_device_type_id === item.asset_device_type_id)
    },
  },
  destroyed() {
    this.changeBarcodeScanner(true);
  },
  created() {
    this.changeBarcodeScanner();
    //
  },
  mounted() {
    /* 
进入页面时首先请求baseData然后再请求列表数据，
避免table的render函数因为baseData还未取到就渲染页面
*/
    // this.doSearch();
    this.initAssetBaseData();
    this.initAssetTopItem();
    if (window.localStorage.getItem(this.print_key)) {
      const row = JSON.parse(window.localStorage.getItem(this.print_key));
      window.localStorage.removeItem(this.print_key);
      this.$refs.applicationPrinter.print([row], false);
    }
  },
  methods: {
    printOne(row) {
      console.log(row);
      const first_asset = row;
      if (!first_asset.customer_id) {
        this.$Modal.warning({
          title: "提示",
          content: "请指定资产使用人后再添加打印!",
        });
        return;
      }
      window.localStorage.setItem(this.print_key, JSON.stringify(row));
      window.open("/exec/assets", "_blank");
    },
    changeAssetDeviceType(val) {
      const asset_name_id = this.params.asset_name_id;
      const is_current =
        this.asset_names_hash &&
        this.asset_names_hash[asset_name_id] &&
        this.asset_names_hash[asset_name_id].asset_device_type_id === val;
      if (val && !is_current) {
        this.params.asset_name_id = 0;
      }

      this.$nextTick(() => {
        this.doSearch();
      });
    },
    closePrint(is_arr) {
      if (is_arr) {
        this.is_batch = 1;
      }
    },
    batchPrint() {
      this.is_batch = 2;
      this.$refs.assetCheckPrint.print(this.selected_assets);
    },
    batchCancel() {
      if (this.selected_assets && this.selected_assets.length) {
        this.is_batch = 1;
      }
    },
    handleSelectItemFromModal() {
      const hash = this.selected_assets.reduce((t, i) => {
        t[i.id] = true;
        return t;
      }, {});

      const tableData = this.$refs.assets.objData || {};
      Object.values(tableData).forEach((item) => {
        if (hash[item.id]) {
          item._isChecked = true;
        } else {
          item._isChecked = false;
        }
      });
    },
    delSelect(index) {
      this.selected_assets.splice(index, 1);
    },
    batchProcessing() {
      this.is_batch = 1;
    },
    matchingItem(search) {
      search = search || this.matching_params.search;
      const selected_assets_uid = this.selected_assets.map((item) => item.uid);
      if (selected_assets_uid.includes(search)) {
        this.$Message.warning("该条资产已在列表中");
        return;
      }
      queryAssetApi(this.matching_params)
        .then((res) => {
          let go = null;
          res.assets.forEach((item) => {
            if (item.uid === this.matching_params.search) {
              go = item;
            }
          });
          if (go) {
            this.selected_assets.push(go);
          } else {
            this.$Message.warning("未匹配");
          }
        })
        .catch(() => {
          this.$Message.warning("未匹配");
        });
    },
    barcodeScannerInput(e) {
      if (this.is_batch !== 1) {
        return;
      }
      const time = +new Date();
      if (this.input_arr.length === 0) {
        this.input_arr.push({
          time,
          key: e.key,
        });
        return;
      }
      const last = this.input_arr[this.input_arr.length - 1];
      if (time - last.time > 100) {
        this.input_arr = [
          {
            time,
            key: e.key,
          },
        ];
      } else {
        this.input_arr.push({
          time,
          key: e.key,
        });
      }
      if (e.key === "Enter") {
        e.preventDefault();
        this.$nextTick(() => {
          const str = this.input_arr
            .filter((item) => item.key.length === 1)
            .map((item) => item.key)
            .join("");
          this.input_arr = [];
          this.matching_params.search = str;
          this.$nextTick(() => {
            this.matchingItem(str);
          });
        });
        return false;
      }
    },
    changeBarcodeScanner(is_colse = false) {
      if (is_colse) {
        window.removeEventListener("keydown", this.barcodeScannerInput);
      } else {
        window.addEventListener("keydown", this.barcodeScannerInput);
      }
    },
    rowClassName({ purchase_date = "" } = {}, index) {
      if (!purchase_date) {
        return "";
      }
      const year = Number(purchase_date.slice(0, 4)) + 3;
      const month_day = purchase_date.slice(4);
      return moment().format("YYYY-MM-DD") > year + month_day ? "red-row" : "";
    },
    changeDeviceType() {
      this.edit_asset.asset_name_id = "";
    },
    changeTax(e) {
      let value = parseFloat(e.target.value);
      if (value > this.edit_asset.price) {
        return false;
      }
      if (isNaN(value)) {
        value = 0;
      }
      this.edit_asset.tax_point = (this.edit_asset.price - value).toFixed(2);
      this.edit_asset.is_estimate_price = false;
    },
    changeInPrice(e) {
      let value = e.target.value;
      if (value > this.edit_asset.price) {
        return false;
      }
      if (isNaN(value)) {
        value = 0;
      }
      this.edit_asset.in_price = (this.edit_asset.price - value).toFixed(2);
      this.edit_asset.is_estimate_price = false;
    },
    calculatePrice(e) {
      let value = 0;
      if (!e.target) {
        value = e;
      } else {
        value = parseFloat(e.target.value);
      }
      if (!isNaN(value)) {
        this.edit_asset.tax_point = (
          (value / (1 + this.tax_rate)) *
          this.tax_rate
        ).toFixed(2);
        this.edit_asset.in_price = (
          this.edit_asset.price - this.edit_asset.tax_point
        ).toFixed(2);
        this.edit_asset.is_estimate_price = true;
      }
    },
    showExpenseGroup(expense_group) {
      this.show_expense_group = true;
      this.selected_expense_group = expense_group;
    },
    doGenerateExpenseGroup() {
      const asset_ids = this.selected_assets.map((asset) => asset.id);
      const payments = this.asset_payment_table_data.reduce((acc, cur) => {
        acc[cur.asset_id] = cur.payment;
        return acc;
      }, {});
      this.edit_asset_payment_table.loading = true;
      this.$util.ajax
        .post(this.$util.api.generate_asset_expense_groups, {
          asset_ids,
          payments,
        })
        .then((res) => {
          if (res.data.code === 1) {
            this.$Modal.success({ title: "提示", content: "生成付款单成功!" });
            const data = res.data.data;
            const keys = Object.keys(data);
            keys.forEach((asset_id) => {
              const index = this.assets.findIndex(
                (asset) => asset.id === parseInt(asset_id)
              );
              if (index !== -1) {
                const asset = this.assets[index];
                const new_expense_groups = asset.expense_groups
                  ? asset.expense_groups.concat([data[asset_id]])
                  : [data[asset_id]];
                const new_asset = Object.assign(asset, {
                  expense_groups: new_expense_groups,
                });
                this.assets.splice(index, 1, new_asset);
              }
            });
            this.selected_assets = [];
            this.edit_asset_payment_table.modal = false;
            this.is_batch = 0;
          } else {
            this.$Modal.error({ title: "错误", content: res.data.msg });
            this.edit_asset_payment_table.loading = false;
          }
        });
    },
    setPayeeAccount(account_obj) {
      // Object.assign(this.edit_asset, account_obj);
      this.edit_asset.payee_company_id = account_obj.payee_company_id;
      this.edit_asset.payee_company_account_id =
        account_obj.payee_company_account_id;
      this.selected_payee_company_account_name = account_obj.payee_company;
    },
    addSelection(selection, row) {
      // console.log('selection', selection, row)
      this.selected_assets.push(row);
    },
    setSelections(selection) {
      selection.forEach((row) => {
        if (!this.selected_assets.find((asset) => asset.id === row.id)) {
          this.selected_assets.push(row);
        }
      });
      // this.selected_assets = selection
    },
    removeSelection(selection, row) {
      // console.log('selection', selection, row)
      const index = this.selected_assets.findIndex(
        (asset) => asset.id === row.id
      );
      // console.log('asset.id', asset)
      this.selected_assets.splice(index, 1);
    },
    clearSelection(selection) {
      this.selected_assets = selection;
    },
    generateExpenseGroups() {
      const selected_assets = this.selected_assets;
      const selected_asset_length = selected_assets.length;
      if (
        selected_assets.find(
          (selected_asset) =>
            !selected_asset.asset_stock && !selected_asset.customer
        )
      ) {
        this.$Message.error("存在未入库资产!");
        return;
      }
      for (let i = 0; i < selected_asset_length; i++) {
        if (!selected_assets[i].team_id) {
          this.$Message.error("有资产尚未设置项目组!");
          return;
        }
      }
      for (let i = 0; i < selected_asset_length; i++) {
        if (!selected_assets[i].payee_company_id) {
          this.$Message.error("有资产尚未设置供应商!");
          return;
        }
      }

      const asset_ids = selected_assets.map((asset) => asset.id);
      const company_ids = selected_assets.map(
        (asset) => asset.payee_company_id
      );
      Util.ajax
        .get(Util.api.query_all_asset_rule_monthly_payee_company)
        .then((result) => {
          const monthly_payee_companies = result.data.data;
          const company_ids_length = company_ids.length;
          for (let i = 0; i < company_ids_length; i++) {
            if (
              !monthly_payee_companies.find(
                (monthly_payee_company) =>
                  monthly_payee_company.payee_company_id === company_ids[i]
              )
            ) {
              this.$Message.error("存在非月结供应商资产!");
              return;
            }
          }
          return Util.ajax.get(Util.api.query_asset_expense_team_by_asset_ids, {
            params: {
              asset_ids,
            },
          });
        })
        .then((res) => {
          if (res) {
            const data = res.data.data;
            let havePayed = false;
            this.asset_payment_table_data = selected_assets.map((asset) => {
              const rest_payment = (
                asset.price -
                data[asset.id].reduce((acc, cur) => {
                  acc += parseFloat(cur.payment);
                  return acc;
                }, 0)
              ).toFixed(2);
              if (rest_payment <= 0) {
                havePayed = true;
              }
              return {
                asset_id: asset.id,
                payment: rest_payment,
                rest_payment,
                asset_name: asset.asset_name.name,
                asset_uid: asset.uid,
              };
            });
            if (havePayed) {
              this.$Message.error("存在已经付完款的资产!");
              return;
            }
            this.edit_asset_payment_table.modal = true;
          }
        });
    },
    multipleInStock() {
      if (!this.selected_assets.length) {
        this.$Message.error("未选择资产!");
        return;
      }
      if (
        this.selected_assets.find(
          (selected_asset) => selected_asset.customer
        ) ||
        this.selected_assets.find(
          (selected_asset) => selected_asset.asset_stock
        )
      ) {
        this.$Message.error("存在已入库的资产!");
        return;
      }
      this.is_batch = 2;
      this.set_user_asset = this.selected_assets[0];
      this.asset_stock_configs[0].modal = true;
      this.asset_stock_configs[0].multiple = true;
    },
    multipleProvide() {
      if (!this.selected_assets.length) {
        this.$Message.error("未选择资产!");
        return;
      }
      if (
        this.selected_assets.find(
          (selected_asset) => !selected_asset.asset_stock
        )
      ) {
        this.$Message.error("存在未在仓库的资产!");
        return;
      }
      this.is_batch = 2;
      this.set_user_asset = this.selected_assets[0];
      this.asset_stock_configs[1].modal = true;
      this.asset_stock_configs[1].multiple = true;
    },
    multipleTransfer() {
      if (!this.selected_assets.length) {
        this.$Message.error("未选择资产!");
        return;
      }
      if (
        this.selected_assets.find(
          (selected_asset) =>
            !selected_asset.asset_stock && !selected_asset.customer
        )
      ) {
        this.$Message.error("存在未入库资产!");
        return;
      }
      if (
        this.selected_assets.find(
          (selected_asset) => selected_asset.customer
        ) &&
        this.selected_assets.find(
          (selected_asset) => selected_asset.asset_stock
        )
      ) {
        this.$Message.error("同时存在仓库资产和用户资产!");
        return;
      }
      this.is_batch = 2;
      this.set_user_asset = this.selected_assets[0];
      this.asset_stock_configs[2].modal = true;
      this.asset_stock_configs[2].multiple = true;
    },
    multipleReturn() {
      if (!this.selected_assets.length) {
        this.$Message.error("未选择资产!");
        return;
      }
      if (
        this.selected_assets.find((selected_asset) => !selected_asset.customer)
      ) {
        this.$Message.error("存在非用户资产!");
        return;
      }
      this.is_batch = 2;
      this.set_user_asset = this.selected_assets[0];
      this.asset_stock_configs[3].modal = true;
      this.asset_stock_configs[3].multiple = true;
    },
    getReceiver(asset, index) {
      if (index === 2) {
        this.asset_stock_configs[index].receiver = asset.asset_stock
          ? { name: "转移仓库", type: "stock" }
          : { name: "转移人员", type: "customer" };
        return this.asset_stock_configs[index].receiver;
      } else {
        return this.asset_stock_configs[index].receiver;
      }
    },
    initAssetTopItem() {
      // this.queryItem('asset_type'); // 设备类型
      // this.queryItem('asset_name');
      // this.queryItem('asset_device_type');
      // this.queryItem('asset_brand');
      // this.queryItem('asset_stock');
      // this.queryItem('payee_company');
    },
    initAssetBaseData() {
      Util.ajax
        .get(Util.api.asset_base_data, {
          params: {},
        })
        .then((response) => {
          return response.data;
        })
        .then((res) => {
          if (res.code === 1) {
            this.doSearch();
            const data = res.data;
            this.asset_brands = data.asset_brands;
            this.asset_purposes = data.asset_purpose;
            this.asset_brands.forEach((item) => {
              this.asset_brands_hash[item.id] = item;
            });
            this.asset_purposes.forEach((item) => {
              this.asset_purposes_hash[item.id] = item;
            });
            this.asset_device_types = data.asset_device_types;
            this.asset_device_types.forEach((item) => {
              this.asset_device_types_hash[item.id] = item;
            });
            this.asset_names = data.asset_names;
            this.asset_names.forEach((item) => {
              this.asset_names_hash[item.id] = item;
              if (!this.asset_names_type_hash[item.asset_device_type_id]) {
                this.asset_names_type_hash[item.asset_device_type_id] = [];
              }
              this.asset_names_type_hash[item.asset_device_type_id].push(item);
            });

            this.asset_locations = data.asset_locations;
            this.asset_locations.forEach((item) => {
              this.asset_locations_hash[item.id] = item;
            });
            this.asset_stocks = data.asset_stocks.filter(
              (asset_stock) => asset_stock.asset_stock_type !== 0
            );
            this.asset_no_use_stock = data.asset_stocks.filter(
              (asset_stock) => asset_stock.asset_stock_type === 0
            )[0];
            this.asset_stocks.forEach((item) => {
              this.asset_stocks_hash[item.id] = item;
            });
            this.asset_versions = data.asset_versions;
          } else {
            this.$Modal.error({ title: "错误", content: res.msg });
          }
        })
        .catch((e) => {
          this.$Modal.error({
            title: "错误",
            content: e.message,
          });
        });
    },
    editAsset(asset) {
      const defaultVals = {
        // 所属公司 终生成长
        company_id: this.companies.find(
          (item) => item.short_name === "终身成长"
        )
          ? this.companies.find((item) => item.short_name === "终身成长").id
          : null,
        // 所属项目组 行政
        team_id: this.teams.find((item) => item.name.includes("行政"))
          ? this.teams.find((item) => item.name.includes("行政")).id
          : null,
        // 地点 C区办公室
        asset_location_id: this.asset_locations.find(
          (item) => item.name === "C区办公室"
        )
          ? this.asset_locations.find((item) => item.name === "C区办公室").id
          : null,
        // 资产用途 办公
        asset_purpose_id: this.asset_purposes.find(
          (item) => item.name === "办公"
        )
          ? this.asset_purposes.find((item) => item.name === "办公").id
          : null,
        // 购买日期 当日
        purchase_date: Util.formatDate(),
      };
      this.edit_asset = Util.clone({
        ...asset,
        ...(asset.id === 0 ? defaultVals : {}),
      });
      // row.payee_company.name
      //  this.selected_payee_company_account_name
      if (this.edit_asset.id) {
        this.selected_payee_company_account_name =
          this.edit_asset.payee_company.name;
      }
      this.edit_config.modal = true;
    },
    editOK() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.edit_config.loading = true;
          const params = {};
          const need_key = [
            "id",
            "uid",
            "asset_device_type_id",
            "asset_name_id",
            "asset_version_id",
            "company_id",
            "team_id",
            "asset_brand_id",
            "payee_company_id",
            "payee_company_account_id",
            "sn",
            "asset_location_id",
            "asset_purpose_id",
            "purchase_date",
            "price",
            "in_price",
            "depreciation_year",
            "residual_value",
            "invoice_type",
            "tax_point",
            "is_estimate_price",
            "extra",
            "desc",
          ];
          if (this.edit_asset.purchase_date instanceof Date) {
            this.edit_asset.purchase_date = this.$util.formatDate(
              this.edit_asset.purchase_date
            );
          }
          // illegality_value
          need_key.forEach((key) => {
            params[key] = !illegality_value.includes(this.edit_asset[key])
              ? this.edit_asset[key]
              : undefined;
          });
          if (params.invoice_type === 0) {
            delete params.is_estimate_price;
            delete params.tax_point;
          }
          Util.ajax
            .post(Util.api.update_asset, params)
            .then((response) => {
              return response.data;
            })
            .then((data) => {
              if (data.code === 1) {
                this.edit_config.modal = false;
                Util.insertOrUpdateArrayItem(this.assets, data.asset, true);
                this.$Message.success({
                  content: "保存成功!",
                });
              } else {
                // this.edit_config.loading = false;
                // setTimeout(() => {
                //   this.edit_config.loading = true;
                // }, 500);
                this.$Modal.error({
                  title: "提示",
                  content: data.msg,
                });
              }
            })
            .catch((e) => {
              // this.edit_config.loading = false;
              // setTimeout(() => {
              //   this.edit_config.loading = true;
              // }, 500);
              console.log(e);
              this.$Message.error({
                content: "操作失败!",
              });
            })
            .finally(() => {
              this.edit_config.loading = false;
            });
        }
      });
    },
    doSearch() {
      this.$nextTick(() => {
        this.$refs.searchBtn.doAjax();
      });
    },
    doSearchCustomer(query) {
      if (this.$refs.searchCustomerBtn.length > 0) {
        if (query && typeof query === "string") {
          this.searching_customer = true;
          this.search_customer_params.search = query;
        }
        this.$refs.searchCustomerBtn[0].doAjax();
      } else {
        if (query && typeof query === "string") {
          this.searching_customer = true;
          this.search_customer_params.search = query;
        }
        this.$refs.searchCustomerBtn.doAjax();
      }
    },
    pageChange(new_page) {
      this.params.page = new_page;
      this.loading = true;
      // this.check_all = false
      // this.indeterminate = false
      // console.log('asset_select', this.$refs.assets)
      this.$nextTick(() => {
        this.$refs.searchBtn.doAjax();
      });
      // this.$refs.searchBtn.doAjax(true);
    },
    beforeSearch() {
      this.params.page = 1;
      this.loading = true;
      this.empty_tip = "获取数据中...";
      this.customers = [];
    },
    handleData(data) {
      this.loading = false;
      this.check_all = false;
      this.indeterminate = false;
      this.assets = [];
      let check_all = true;
      data.assets.forEach((asset) => {
        // if (this.selected_assets.find(selected => selected.id === asset.id)) {
        //   asset._checked = true
        // }
        this.assets.push(asset);
        if (this.print_list.find((print) => print.id === asset.id)) {
          this.indeterminate = true;
        } else {
          check_all = false;
        }
      });
      if (check_all) {
        this.indeterminate = false;
      }
      this.check_all = check_all;
      if (data.assets.length === 0) {
        this.empty_tip = "没有结果, 请重试!";
      }
      this.page_info.current = data.cur_page;
      this.page_info.page_size = data.per_page;
      this.page_info.total = data.total_count;
      this.$nextTick(() => {
        this.handleSelectItemFromModal();
      });
    },
    handleFail(e) {
      this.loading = false;
      this.empty_tip = "获取数据失败, 请重试";
      console.log(e);
    },
    queryItem(type) {
      const loading_key = `search_${type}_loading`;
      const data_key = `search_${type}_results`;
      const data_hash = `${type}_hash`;
      if (!this[loading_key]) {
        this[loading_key] = true;
        Util.ajax
          .get(Util.api[`query_${type}`], {
            params: {
              search: this[`search_${type}_text`],
              page: 1,
              per_page: 10,
              order: "use_count",
            },
          })
          .then((response) => {
            return response.data;
          })
          .then((res) => {
            this[loading_key] = false;
            if (res.code === 1) {
              const data = res.data;
              this[data_key] = [];
              data.items.forEach((item) => {
                this[data_key].push(item);
                this[data_hash][item.id] = item;
              });
            } else {
              this.$Modal.error({
                title: "错误",
                content: res.msg,
              });
            }
          })
          .catch((e) => {
            this[loading_key] = false;
            console.log(e);
            this.$Modal.error({
              title: "错误",
              content: e.message,
            });
          });
      }
    },
    setItem(type, item) {
      this[`${type}_hash`][item.id] = item;
      this.edit_asset[`${type}_id`] = item.id;
      document.body.click();
    },
    setLocation(location) {
      this.edit_asset.location = location;
      document.body.click();
    },
    purchaseDateChange(date) {
      this.edit_asset.purchase_date = date;
    },
    arriveDateChange(date) {
      this.edit_asset.arrive_date = date;
    },
    getDateChange(date) {
      console.log(date);
    },
    handleAssetEvent(event_name, asset) {
      switch (event_name) {
        case "edit":
          this.editAsset(asset);
          break;
        case "print":
          this.printAsset(asset);
          break;
        case "print_application":
          this.printApplication(asset);
          break;
        case "in_stock":
          this.assetStockConfig(asset, 0);
          break;
        case "provide":
          this.assetStockConfig(asset, 1);
          break;
        case "transfer":
          this.assetStockConfig(asset, 2);
          break;
        case "return":
          this.assetStockConfig(asset, 3);
          break;
        case "discard":
          this.disCardAsset(asset, 4);
          break;
        case "copy":
          this.copyAsset(asset);
          break;
        // case 'delete':
        //     this.abandonAsset(asset);
        //     break;
        case "edit_desc":
          this.editDesc(asset);
          break;
        default:
          this.$Message.error("未定义操作!");
          break;
      }
    },
    printAsset(asset) {
      //window.open('/web/asset/print/'+asset.id, '_blank');
      this.$refs.printer.print(asset);
    },
    printApplication(asset) {
      this.$refs.applicationPrinter.print([asset]);
    },
    printApplications() {
      if (this.print_list.length) {
        const first_asset = this.print_list[0];
        if (!first_asset.customer_id) {
          this.$Modal.warning({
            title: "提示",
            content: "请指定资产使用人后再添加打印!",
          });
          return;
        }
        const first_asset_length = this.print_list.length;
        for (let i = 1; i < first_asset_length; i++) {
          const asset = this.print_list[i];
          if (
            !asset.customer ||
            asset.customer.id !== first_asset.customer.id
          ) {
            this.$Modal.warning({
              title: "提示",
              content: "领用表中的使用人必须为同一人!",
            });
            return;
          }
          // if(this.isInPrintList(asset)){
          //     this.$Modal.warning({
          //         title: '提示',
          //         content: '已添加进领用表, 无需重复添加!'
          //     });
          //     return;
          // }
        }
        this.$refs.applicationPrinter.print(this.print_list);
      } else {
        this.$Message.warning("请添加资产到领用表!");
      }
    },
    addToPrintList(asset) {
      if (!asset.customer_id) {
        this.$Modal.warning({
          title: "提示",
          content: "请指定资产使用人后再添加打印!",
        });
        return;
      }
      if (this.print_list.length) {
        const first_asset = this.print_list[0];
        if (
          !asset.customer_id ||
          asset.customer.id !== first_asset.customer.id
        ) {
          this.$Modal.warning({
            title: "提示",
            content: "领用表中的使用人必须为同一人!",
          });
          return;
        }
      }
      if (this.isInPrintList(asset)) {
        this.$Modal.warning({
          title: "提示",
          content: "已添加进领用表, 无需重复添加!",
        });
        return;
      }
      this.print_list.push(asset);
    },
    addAssetsToPrintList(assets) {
      assets.forEach((asset) => {
        if (!this.print_list.find((print) => print.id === asset.id)) {
          this.print_list.push(asset);
        }
      });
    },
    clearPrintList() {
      this.print_list = [];
      this.check_all = false;
      this.indeterminate = false;
    },
    isInPrintList(asset) {
      return Util.isArrayItem(this.print_list, asset);
    },
    moveUpAssetInPrintList(index) {
      Util.moveUpArrayItemByIndex(this.print_list, index);
    },
    moveDownAssetInPrintList(index) {
      Util.moveDownArrayItemByIndex(this.print_list, index);
    },
    removeAssetInPrintList(index) {
      Util.removeArrayItemByIndex(this.print_list, index);
      this.indeterminate = true;
      if (this.print_list.length === 0) {
        this.check_all = false;
        this.indeterminate = false;
      }
    },
    // provide(asset){

    // },
    // transfer(asset) {

    // },
    // discard(asset) {

    // },
    // inStock() {},
    assetStockConfig(asset, type) {
      if (!this.getting_target_asset) {
        this.getting_target_asset = true;
        Util.ajax
          .get(Util.api.query_asset_by_id, {
            params: {
              id: asset.id,
            },
          })
          .then((response) => {
            return response.data;
          })
          .then((res) => {
            this.getting_target_asset = false;
            if (res.code === 1) {
              this.set_user_asset = res.data;
              this.asset_stock_configs[type].modal = true;
            } else {
              this.$Modal.error({
                title: "错误",
                content: res.msg,
              });
            }
          })
          .catch((e) => {
            this.getting_target_asset = false;
            this.$Modal.error({
              title: "错误",
              content: e.message,
            });
            console.log(e);
          });
      }
    },
    copyAsset(asset) {
      const new_asset = Util.clone(asset);
      delete new_asset.id;
      delete new_asset.uid;
      new_asset.sn = "";
      new_asset.pn = "";
      new_asset.imei = "";
      this.editAsset(new_asset);
    },
    abandonAsset() {
      this.$Message.warning("暂未开放删除功能!");
    },
    editDesc() {
      //
    },
    // checkSetUserValid(){
    //     if(!this.set_customer_date){
    //         this.$Modal.error({
    //             title: '提示',
    //             content: '请选择领用日期'
    //         });
    //         this.save_user_config.loading = false;
    //         setTimeout(()=>{
    //             this.save_user_config.loading = true;
    //         }, 500);
    //         return false;
    //     }
    //     return true;
    // },
    setMultipleUserOK(type) {
      if (!this.set_customer_date) {
        this.$Message.error("请设置日期!");
        this.asset_stock_configs[type].sub_loading = false;
        setTimeout(() => {
          this.asset_stock_configs[type].sub_loading = true;
        }, 500);
        return;
      }
      const params = {};
      params.asset_ids = this.selected_assets.map(
        (selected_asset) => selected_asset.id
      );
      if (type === 0) {
        params.asset_stock_id = this.selected_stock.id;
      } else if (type === 1) {
        params.from_stock_ids = this.selected_assets.map(
          (selected_asset) => selected_asset.asset_stock_id
        );
        params.customer_id = this.selected_customer.id;
      } else if (type === 2) {
        if (this.selected_assets[0].customer_id) {
          params.from_customer_ids = this.selected_assets.map(
            (selected_asset) => selected_asset.customer_id
          );
          params.customer_id = this.selected_customer.id;
        } else {
          params.from_stock_ids = this.selected_assets.map(
            (selected_asset) => selected_asset.asset_stock_id
          );
          params.asset_stock_id = this.selected_stock.id;
        }
      } else if (type === 3) {
        params.from_customer_ids = this.selected_assets.map(
          (selected_asset) => selected_asset.customer_id
        );
        params.asset_stock_id = this.selected_stock.id;
      }
      params.execute_date = this.$util.formatDate(this.set_customer_date);
      params.type = type;
      Util.ajax
        .post(Util.api.add_asset_in_out_records, params)
        .then((response) => {
          return response.data;
        })
        .then((res) => {
          if (res.code === 1) {
            const data = res.data;
            this.asset_stock_configs[type].sub_modal = false;
            // this.set_user_asset = data.full_info;
            data.forEach((asset) => {
              Util.insertOrUpdateArrayItem(this.assets, asset);
            });
          } else {
            this.asset_stock_configs[type].sub_loading = false;
            setTimeout(() => {
              this.asset_stock_configs[type].sub_loading = true;
            }, 500);
            this.$Modal.error({
              title: "错误",
              content: res.msg,
            });
          }
          this.asset_stock_configs[type].modal = false;
          this.asset_stock_configs[type].multiple = false;
          this.selected_assets = [];
          this.is_batch = 0;
        })
        .catch((e) => {
          this.$Message.error("添加使用人失败, 请重试!");
          this.asset_stock_configs[type].sub_loading = false;
          // this.asset_stock_configs[type].modal = false
          this.asset_stock_configs[type].multiple = false;
          setTimeout(() => {
            this.asset_stock_configs[type].sub_loading = true;
          }, 500);
          this.selected_assets = [];
          this.is_batch = 0;
          console.log(e);
        });
    },
    setUserOK(type) {
      if (!this.set_customer_date) {
        this.$Message.error("请设置日期!");
        this.asset_stock_configs[type].sub_loading = false;
        setTimeout(() => {
          this.asset_stock_configs[type].sub_loading = true;
        }, 500);
        return;
      }
      const params = {};
      const userAssetCustomerId = this.set_user_asset.customer_id;
      if (type === 0) {
        params.asset_stock_id = this.selected_stock.id;
      } else if (type === 1) {
        params.customer_id = this.selected_customer.id;
        params.from_stock_id = this.set_user_asset.asset_stock_id;
      } else if (type === 2) {
        // const editAssetStockId = this.edit_asset.asset_stock_id
        if (userAssetCustomerId) {
          params.customer_id = this.selected_customer.id;
          params.from_customer_id = this.set_user_asset.customer_id;
        } else {
          params.asset_stock_id = this.selected_stock.id;
          params.from_stock_id = this.set_user_asset.asset_stock_id;
        }
      } else if (type === 3) {
        params.from;
        params.asset_stock_id = this.selected_stock.id;
        params.from_customer_id = this.set_user_asset.customer_id;
      } else if (type === 4) {
        if (userAssetCustomerId) {
          params.from_customer_id = this.set_user_asset.customer_id;
        } else {
          params.from_stock_id = this.set_user_asset.asset_stock_id;
        }
        params.asset_stock_id = this.asset_no_use_stock.id;
      }
      if (this.set_customer_desc) {
        params.desc = this.set_customer_desc;
      }
      params.asset_id = this.set_user_asset.id;
      params.execute_date = this.$util.formatDate(this.set_customer_date);
      params.type = type;
      Util.ajax
        .post(Util.api.add_asset_in_out_record, params)
        .then((response) => {
          return response.data;
        })
        .then((res) => {
          if (res.code === 1) {
            const data = res.data;
            this.asset_stock_configs[type].sub_modal = false;
            this.set_user_asset = data.full_info;
            Util.insertOrUpdateArrayItem(this.assets, data.list_info);
          } else {
            this.asset_stock_configs[type].sub_loading = false;
            setTimeout(() => {
              this.asset_stock_configs[type].sub_loading = true;
            }, 500);
            this.$Modal.error({
              title: "错误",
              content: res.msg,
            });
          }
        })
        .catch((e) => {
          this.$Message.error("添加使用人失败, 请重试!");
          this.asset_stock_configs[type].sub_loading = false;
          setTimeout(() => {
            this.asset_stock_configs[type].sub_loading = true;
          }, 500);
          console.log(e);
        });
    },
    addCustomerToAsset(customer, index) {
      this.selected_customer = customer;
      this.asset_stock_configs[index].sub_modal = true;
    },
    addStockToAsset(stock_id, index) {
      this.selected_stock = this.asset_stocks.find(
        (stock) => stock.id === stock_id
      );
      this.asset_stock_configs[index].sub_modal = true;
    },
    disCardAsset(asset, index) {
      this.set_user_asset = asset;
      this.asset_stock_configs[index].sub_modal = true;
    },
    deleteAssetCustomer(asset_customer, index) {
      if (!this.asset_customer_deleting) {
        this.asset_customer_deleting = true;
        Util.ajax
          .post(Util.api.delete_asset_customer, {
            asset_: asset_customer.id,
          })
          .then((response) => {
            return response.data;
          })
          .then((res) => {
            this.asset_customer_deleting = false;
            if (res.code === 1) {
              this.set_user_asset.asset_customers.splice(index, 1);
            } else {
              this.$Modal.error({
                title: "错误",
                content: res.msg,
              });
            }
          })
          .catch((e) => {
            this.asset_customer_deleting = false;
            this.$Message.error("删除失败, 请重试!");
            console.log(e);
          });
      }
    },
    handleSearchCustomerData(data) {
      if (data.length > 0) {
        this.searched_customers = [];
        data.forEach((customer) => {
          this.searched_customers.push(customer);
        });
        this.searching_customer = false;
        this.search_customer_params.search = "";
      } else {
        if (!this.searching_customer) {
          this.$Message.error("没有搜索到相关信息");
        }
        this.searching_customer = false;
        this.search_customer_params.search = "";
      }
    },
    handleSearchCustomerFail() {
      this.$Message.error("搜索失败, 请重试!");
      this.searching_customer = false;
      this.search_customer_params.search = "";
    },
    getItemNameById(type, id) {
      const item = (this[`${type}_hash`] || {})[id];
      return item ? item.name : "-";
    },
    formatPrice(price) {
      price = price ? price : 0;
      return math.eval(price).toFixed(2);
    },
    showCustomerAssets(customer) {
      this.$refs.CustomerAsset.show(customer);
    },
    updateSetUserAssetTeam(asset, value) {
      this.update_asset_team_id = asset.team_id;
      this.is_update_team = value;
    },
    updateAssetTeam(asset) {
      if (this.update_team_loading) return;
      this.update_team_loading = true;
      Util.ajax
        .post(Util.api.update_asset_team, {
          id: asset.id,
          team_id: this.update_asset_team_id,
        })
        .then((response) => {
          return response.data;
        })
        .then((res) => {
          if (res.code === 1) {
            this.is_update_team = false;
            asset.team_id = this.update_asset_team_id;
            this.$Message.success("修改团队成功!");
          } else {
            this.$Modal.error({ title: "错误", content: res.msg });
          }
        })
        .catch((e) => {
          this.$Modal.error({ title: "错误", content: e.message });
        })
        .finally(() => {
          this.update_team_loading = false;
        });
    },
    importAssets() {
      this.import_config.modal = true;
    },
    importFinish() {
      this.$Modal.success({ title: "提示", content: "上传成功!" });
    },
    exportAssets() {
      window.open(
        Util.api.export_assets + ".xlsx?" + Util.urlEncode(this.params),
        "_blank"
      );
    },
  },
};
</script>
